import * as Yup from "yup";
import { REGEX } from "../../../utils/constants";
/**
 * @description declaration form schema for client validations
 */
export const userSchema = Yup.object().shape({
  email: Yup.string()
    .email("Invalid email address")
    .required("Email address field  is required"),
  fname: Yup.string()
    .trim()
    .required("This field is required")
    .max(50, "This field should be maximumun 50 characters.")
    .matches(REGEX.NAME, "This field only accepts alphabets!"),
  lname: Yup.string()
    .trim()
    .required("This field is required")
    .max(50, "This field should be maximumun 50 characters.")
    .matches(REGEX.NAME, "This field only accepts alphabets!"),
  phone: Yup.string()
  .trim()
  .matches(
    /^(\([0-9]{3}\) |[0-9]{3}-)?[0-9]{3}-[0-9]{4}$/,
    "Invalid Phone Number"
  )
  .required("This field is required"),
  location: Yup.string(),
  purchase_advice: Yup.bool().oneOf([true, false]),
});

/**
 * @description declaration form schema for operator update validations
 */
export const operatorUpdateSchema = Yup.object().shape({
  email: Yup.string()
    .email("Invalid email address")
    .required("Email address field  is required"),
  fname: Yup.string()
    .trim()
    .required("This field is required")
    .max(50, "This field should be maximumun 50 characters.")
    .matches(REGEX.NAME, "This field only accepts alphabets!"),
  lname: Yup.string()
    .trim()
    .required("This field is required")
    .max(50, "This field should be maximumun 50 characters.")
    .matches(REGEX.NAME, "This field only accepts alphabets!"),
  phone: Yup.string()
    .required("This field  is required")
    .matches(REGEX.PHONE, "Phone Number not valid"),
  location: Yup.string(),
  purchase_advice: Yup.bool().oneOf([true, false]),
});

/**
 * @description params intilaization
 */

export const userInit = {
  email: "",
  phone: "",
  fname: "",
  lname: "",
  location: "",
  purchase_advice: false,
  roles: "",
  permissions: [],
};
